// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload_files {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: linear-gradient(to right, #d6dcd7 50%, transparent 0%) top
      repeat-x,
    linear-gradient(#d6dcd7 50%, transparent 0%) right repeat-y,
    linear-gradient(to right, #d6dcd7 50%, transparent 0%) bottom repeat-x,
    linear-gradient(#d6dcd7 50%, transparent 0%) left repeat-y;
  background-size: 10px 1.3px, 1.3px 10px;
}

.center-content {
  padding-top: 60px;
  padding-bottom: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  flex-direction: column; 
}

.plus-bar {
  position: absolute;
  border-radius: 10px;
  background-color: white;
}

.horizontal {
  width: 54%;
  height: 8%;
  top: 44%;
  left: 23%;
}

.vertical {
  width: 8%;
  height: 54%;
  top: 22%;
  left: 47%;
}
`, "",{"version":3,"sources":["webpack://./src/containers/fileUpload/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB;;;;8DAI4D;EAC5D,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;EACX,QAAQ;EACR,SAAS;AACX","sourcesContent":[".upload_files {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  background: linear-gradient(to right, #d6dcd7 50%, transparent 0%) top\n      repeat-x,\n    linear-gradient(#d6dcd7 50%, transparent 0%) right repeat-y,\n    linear-gradient(to right, #d6dcd7 50%, transparent 0%) bottom repeat-x,\n    linear-gradient(#d6dcd7 50%, transparent 0%) left repeat-y;\n  background-size: 10px 1.3px, 1.3px 10px;\n}\n\n.center-content {\n  padding-top: 60px;\n  padding-bottom: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n  flex-direction: column; \n}\n\n.plus-bar {\n  position: absolute;\n  border-radius: 10px;\n  background-color: white;\n}\n\n.horizontal {\n  width: 54%;\n  height: 8%;\n  top: 44%;\n  left: 23%;\n}\n\n.vertical {\n  width: 8%;\n  height: 54%;\n  top: 22%;\n  left: 47%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
